<template>
    <div class="openapi-page" v-loading.fullscreen.lock="state.fullLoading">
        <el-card>
            <template #header>
                <div class="page-header">
                    <span>开放应用管理</span>
                    <el-button type="primary" @click="openAppDialog()">新增应用</el-button>
                </div>
            </template>
            <el-form :model="search" label-width="90px" class="search-form">
                <el-row :gutter="16">
                    <el-col :span="6"><el-form-item label="应用名称"><el-input v-model="search.appName" clearable @keyup.enter="searchData" /></el-form-item></el-col>
                    <el-col :span="6"><el-form-item label="AppKey"><el-input v-model="search.appKey" clearable @keyup.enter="searchData" /></el-form-item></el-col>
                    <el-col :span="6"><el-form-item label="商户ID"><el-input v-model="search.merchantId" clearable @keyup.enter="searchData" /></el-form-item></el-col>
                    <el-col :span="6"><el-form-item label="状态"><el-select v-model="search.status" clearable style="width: 100%"><el-option label="启用" value="ENABLED" /><el-option label="停用" value="DISABLED" /></el-select></el-form-item></el-col>
                </el-row>
                <div class="search-actions">
                    <el-button type="primary" @click="searchData">查询</el-button>
                    <el-button @click="resetSearch">重置</el-button>
                </div>
            </el-form>
            <el-table :data="tableData" border height="calc(100vh - 310px)" v-loading="state.tableLoading">
                <el-table-column prop="appName" label="应用名称" min-width="160" />
                <el-table-column prop="merchantId" label="商户ID" min-width="150" />
                <el-table-column prop="testAppKey" label="测试 Key" min-width="220" show-overflow-tooltip /><el-table-column prop="prodAppKey" label="生产 Key" min-width="220" show-overflow-tooltip />
                <el-table-column prop="status" label="状态" width="90"><template #default="scope"><el-tag :type="scope.row.status === 'ENABLED' ? 'success' : 'info'">{{ scope.row.status === 'ENABLED' ? '启用' : '停用' }}</el-tag></template></el-table-column>
                <el-table-column prop="ipWhitelist" label="IP白名单" min-width="180" show-overflow-tooltip />
                <el-table-column prop="dailyLimit" label="日限额" width="100" />
                <el-table-column prop="monthlyLimit" label="月限额" width="100" />
                <el-table-column prop="createTime" label="创建时间" min-width="170" />
                <el-table-column fixed="right" label="操作" width="380">
                    <template #default="scope">
                        <el-button size="small" @click="openAppDialog(scope.row)">编辑</el-button>
                        <el-button size="small" type="primary" @click="viewSecrets(scope.row)">查看密钥</el-button>
                        <el-button size="small" type="warning" @click="resetSecrets(scope.row)">重置双密钥</el-button>
                        <el-button v-if="scope.row.status === 'ENABLED'" size="small" type="danger" @click="toggleApp(scope.row, false)">停用</el-button>
                        <el-button v-else size="small" type="success" @click="toggleApp(scope.row, true)">启用</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box"><el-pagination background layout="total, sizes, prev, pager, next" v-model:current-page="pagination.current" v-model:page-size="pagination.size" :total="pagination.total" :page-sizes="pagination.sizes" @current-change="loadData" @size-change="loadData" /></div>
        </el-card>
        <el-dialog v-model="dialog.visible" :title="dialog.form.id ? '编辑应用' : '新增应用'" width="560px">
            <el-form ref="formRef" :model="dialog.form" :rules="rules" label-width="100px">
                <el-form-item label="应用名称" prop="appName"><el-input v-model="dialog.form.appName" /></el-form-item>
                <el-form-item label="商户ID" prop="merchantId"><el-input v-model="dialog.form.merchantId" /></el-form-item>

                <el-form-item label="状态"><el-radio-group v-model="dialog.form.status"><el-radio label="ENABLED">启用</el-radio><el-radio label="DISABLED">停用</el-radio></el-radio-group></el-form-item>
                <el-form-item label="IP白名单"><el-input v-model="dialog.form.ipWhitelist" placeholder="多个 IP 用英文逗号分隔" /></el-form-item>
                <el-form-item label="日调用上限"><el-input-number v-model="dialog.form.dailyLimit" :min="0" :controls="false" style="width: 100%" /></el-form-item>
                <el-form-item label="月调用上限"><el-input-number v-model="dialog.form.monthlyLimit" :min="0" :controls="false" style="width: 100%" /></el-form-item>
                <el-form-item label="备注"><el-input v-model="dialog.form.remark" type="textarea" :rows="3" /></el-form-item>
            </el-form>
            <template #footer><el-button @click="dialog.visible = false">取消</el-button><el-button type="primary" @click="saveApp">保存</el-button></template>
        </el-dialog>
        <el-dialog v-model="secretDialog.visible" title="应用密钥" width="620px">
            <el-alert title="私钥属于敏感凭证，请仅发送给可信的下游系统并妥善保管。" type="warning" :closable="false" show-icon />
            <div class="secret-list">
                <div class="secret-row">
                    <span class="secret-label">测试 Key</span>
                    <el-input v-model="secretDialog.testAppKey" readonly>
                        <template #append><el-button @click="copySecret(secretDialog.testAppKey, '测试 Key')">复制</el-button></template>
                    </el-input>
                </div>
                <div class="secret-row">
                    <span class="secret-label">生产 Key</span>
                    <el-input v-model="secretDialog.prodAppKey" readonly>
                        <template #append><el-button @click="copySecret(secretDialog.prodAppKey, '生产 Key')">复制</el-button></template>
                    </el-input>
                </div>
                <div class="secret-row">
                    <span class="secret-label">公共私钥</span>
                    <el-input v-model="secretDialog.appSecret" type="password" readonly show-password>
                        <template #append><el-button @click="copySecret(secretDialog.appSecret, '公共私钥')">复制</el-button></template>
                    </el-input>
                </div>
            </div>            <template #footer><el-button @click="secretDialog.visible = false">关闭</el-button></template>
        </el-dialog>
    </div>
</template>
<script setup>
import { reactive, ref, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { getOpenApiAppPage, saveOpenApiApp, enableOpenApiApp, disableOpenApiApp, resetOpenApiSecrets, getOpenApiSecrets } from "@/api/openapi";

const emptySearch = () => ({ appName: "", appKey: "", merchantId: "", status: "" });
const search = reactive(emptySearch());
const state = reactive({ tableLoading: false, fullLoading: false });
const tableData = ref([]);
const pagination = reactive({ current: 1, size: 20, total: 0, sizes: [20, 50, 100] });
const formRef = ref();
const dialog = reactive({ visible: false, form: {} });
const secretDialog = reactive({ visible: false, testAppKey: "", prodAppKey: "", appSecret: "" });
const rules = { appName: [{ required: true, message: "请输入应用名称", trigger: "blur" }], merchantId: [{ required: true, message: "请输入商户ID", trigger: "blur" }] };

function loadData() {
    state.tableLoading = true;
    getOpenApiAppPage({ ...search, current: pagination.current, size: pagination.size }).then((res) => {
        tableData.value = res.data.records || [];
        pagination.total = res.data.total || 0;
    }).finally(() => state.tableLoading = false);
}
function searchData() { pagination.current = 1; loadData(); }
function resetSearch() { Object.assign(search, emptySearch()); searchData(); }
function openAppDialog(row) {
    dialog.form = row ? { ...row } : { status: "ENABLED", dailyLimit: 0, monthlyLimit: 0 };
    dialog.visible = true;
}
function viewSecrets(row) {
    state.fullLoading = true;
    getOpenApiSecrets({ id: row.id }).then((res) => {
        secretDialog.testAppKey = res.data?.testAppKey || row.testAppKey || row.appKey || "";
        secretDialog.prodAppKey = res.data?.prodAppKey || row.prodAppKey || "";
        secretDialog.appSecret = res.data?.appSecret || "";
        secretDialog.visible = true;
    }).finally(() => state.fullLoading = false);
}
async function copySecret(value, label) {
    if (!value) {
        ElMessage.warning(`${label}暂无值`);
        return;
    }
    try {
        if (navigator?.clipboard?.writeText) {
            await navigator.clipboard.writeText(value);
        } else {
            const textarea = document.createElement("textarea");
            textarea.value = value;
            textarea.style.position = "fixed";
            textarea.style.opacity = "0";
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
        }
        ElMessage.success(`${label}已复制`);
    } catch (error) {
        ElMessage.error(`复制${label}失败，请手动选择复制`);
    }
}
function showSecrets(secrets, title) {
    ElMessageBox.alert(
        `<div class="secret-box"><p><b>测试 Key：</b>${secrets.testAppKey}</p><p><b>生产 Key：</b>${secrets.prodAppKey}</p><p><b>公共私钥：</b>${secrets.appSecret}</p><p class="secret-tip">测试和生产使用不同 Key，但共用同一份私钥，请妥善保存。</p></div>`,
        title,
        { confirmButtonText: "我已保存", dangerouslyUseHTMLString: true }
    );
}function saveApp() {
    formRef.value.validate((valid) => {
        if (!valid) return;
        const isCreate = !dialog.form.id;
        state.fullLoading = true;
        saveOpenApiApp(dialog.form).then((res) => {
            ElMessage.success("保存成功");
            dialog.visible = false;
            loadData();
            if (isCreate && res.data?.id) {
                return resetOpenApiSecrets({ id: res.data.id }).then((secretRes) => {
                    showSecrets(secretRes.data, "请保存开放平台双密钥");
                });
            }
        }).finally(() => state.fullLoading = false);
    });
}
function toggleApp(row, enabled) {
    const action = enabled ? enableOpenApiApp : disableOpenApiApp;
    action({ id: row.id }).then(() => { ElMessage.success(enabled ? "已启用" : "已停用"); loadData(); });
}
function resetSecrets(row) {
    ElMessageBox.confirm("重置后旧的 AppKey 和私钥都会立即失效，确定继续？", "重置双密钥", { type: "warning" }).then(() => {
        return resetOpenApiSecrets({ id: row.id });
    }).then((res) => {
        showSecrets(res.data, "请保存新的开放平台双密钥");
    });
}
onMounted(loadData);
</script>
<style lang="scss" scoped>
.openapi-page { padding: 16px; }
.page-header { display: flex; align-items: center; justify-content: space-between; font-weight: 600; }
.search-form { margin-bottom: 12px; }
.search-actions { text-align: right; }
.pagination-box { margin-top: 14px; display: flex; justify-content: flex-end; }
.secret-list { padding-top: 20px; }
.secret-row { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; }
.secret-label { width: 110px; flex: 0 0 110px; color: #606266; text-align: right; }
.secret-row .el-input { flex: 1; }
</style>